import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export const FAQSection = () => {
  const faqs = [{
    question: 'How does ToxicDetector work?',
    answer: "ToxicDetector analyzes conversations to identify patterns of manipulation, gaslighting, and toxic behavior. Upload your screenshots or chat exports, and you'll get a detailed analysis within seconds."
  }, {
    question: 'Is my data private and secure?',
    answer: 'Yes, your privacy is our top priority. All conversations are encrypted and never shared with third parties. We use industry-standard security to ensure complete confidentiality.'
  }, {
    question: 'What types of conversations can I analyze?',
    answer: 'You can analyze text messages, social media chats, email exchanges, and more. We support screenshots, images, PDFs, and direct chat exports from most popular platforms.'
  }, {
    question: 'How accurate is the toxicity detection?',
    answer: 'ToxicDetector has been trained on thousands of examples of healthy and unhealthy communication patterns. While no system is perfect, it typically identifies toxic patterns with high accuracy and provides confidence ratings with each analysis.'
  }, {
    question: 'Can I cancel my subscription anytime?',
    answer: "Yes, you can cancel your Pro subscription at any time. Your subscription will remain active until the end of your current billing period, then it won't renew."
  }];
  return <section className="py-20 bg-white" id="faq" data-id="element-2099" data-mp="c3whicv0pjcg">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2100" data-mp="75v2c30pq469">
        <div className="text-center mb-16" data-id="element-2101" data-mp="76wgwhgxt8sq">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight leading-tight" data-id="element-2102" data-mp="27jtnvm5lzpm">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-2103" data-mp="3tct8qs8m0tkg">
            Everything you need to know about how we protect your peace.
          </p>
        </div>

        <div className="space-y-4" data-id="element-2104" data-mp="3epcgrog24ys0">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-2105" data-mp="3jq8supakbr8i" data-mpi={index} />)}
        </div>
      </div>
    </section>;
};
interface FAQItemProps {
  question: string;
  answer: string;
}
const FAQItem = ({
  question,
  answer
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:border-gray-300 hover:shadow-md transition-all duration-300" data-id="element-2106" data-mp="2asbpqvbtdzg">
      <button className="w-full text-left p-6 flex justify-between items-center gap-4 font-semibold text-gray-900 hover:bg-gray-50 transition-colors focus:outline-none focus:bg-gray-50" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-2107" data-mp="3opbq3nkawt5x">
        <span className="flex-1 text-lg" data-id="element-2108" data-mp="l6a53ye65r7y">{question}</span>
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-50 flex items-center justify-center transition-colors" data-id="element-2109" data-mp="q04sbbszgobs">
          {isOpen ? <Minus size={18} className="text-red-600" data-id="element-2110" data-mp="zbisngkvh55x" /> : <Plus size={18} className="text-red-600" data-id="element-2111" data-mp="vbs1vcvcip1e" />}
        </div>
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-2112" data-mp="1936orusdjadq">
        <div className="px-6 pb-6 text-gray-600 text-base leading-relaxed" data-id="element-2113" data-mp="geretmo3ni99">
          {answer}
        </div>
      </div>
    </div>;
};